// extracted by mini-css-extract-plugin
export default {"container":"folders_dropdown_create_container-module__container--2VZAZ"};